// Copyright (c) 2020 Deere & Company

import {stripAllSpaces} from './strip-spaces';

export const formatPin = pin =>
    stripAllSpaces(pin.toUpperCase());



// WEBPACK FOOTER //
// ./src/shared/services/format-pin.js